import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  positioning: {
    top: -2,
    position: 'relative',
  },
});

export default styles;
